import React, {useState, useEffect} from 'react';

const Storage = ({initialModel, onChange}) => {

  const [model, setModel] = useState(initialModel || {});

  useEffect(() => onChange(model), [model]);

  return <div className="form-check mb-3">
    <input type="checkbox"
           id="formSubmissionStorageEnabled"
           className="form-check-input"
           checked={!!model.enabled}
           onChange={e => setModel({...model, enabled: e.target.checked})} />
    <label className="form-check-label" htmlFor="formSubmissionStorageEnabled">
      Store form submissions
    </label>
    <div className="form-text">If enabled, submissions are stored in an encrypted database. We do not process them in any way.</div>
  </div>;

};

export default Storage;